import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { GlobalServiceProvider } from '../../providers/global-service/global-service';
import { KumpulKumpulProvider } from '../../providers/kumpul-kumpul/kumpul-kumpul';
import { PlatformServiceProvider } from '../../providers/platform/platform-service';
import { RequestAuthorizeThisDeviceDto, RequestCheck2FADto, RequestUpdate2FADto } from '../../shared/nestjs/gd-only/dto/sf-authenticator.dto';
import { SfAuthenticatorApi } from '../../shared/nestjs/gd-only/services/sf-authenticator.api';

@Injectable()
export class AuthenticatorBloc {

    private subscriptions: Array<Subscription> = [];

    constructor(
        private sfAuthenticatorApi: SfAuthenticatorApi,
        private platformService: PlatformServiceProvider,
        private storage: Storage,
        private kumpulKumpulProvider: KumpulKumpulProvider,
        private globalService: GlobalServiceProvider,
    ) {

    }

    public dispose() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    private async generateDeviceID() {
        try {
            let getAuth = await this.storage.get("SFGoAuth");
            const SFGoAuth = JSON.parse(getAuth);
            const checkToken = await this.kumpulKumpulProvider.checkCookie("tokenAuthGo");
            if (!checkToken) {
                const data = await this.kumpulKumpulProvider.setCookie("tokenAuthGo", btoa(SFGoAuth.userName + SFGoAuth.companyId + (new Date().getTime()).toString(36).toLowerCase()), 90);
                return data;
            } else {
                return this.kumpulKumpulProvider.getCookie("tokenAuthGo");
            }
        } catch (error) {
            return null;
        }
    }

    public async checkDevice() {
        try {
            let deviceData = await this.platformService.getPlatform();
            if (!deviceData.DeviceID) {
                deviceData.DeviceID = await this.generateDeviceID();
            }
            const check = await this.check2FA({
                deviceSignature: deviceData.DeviceID
            });
            return Promise.resolve(check)
        } catch (error) {
            return Promise.reject(error);
        }
    }

    public async saveDevice() {
        try {
            let deviceData = await this.platformService.getPlatform();
            if (!deviceData.DeviceID) {
                deviceData.DeviceID = await this.generateDeviceID();
            }
            const IP = await new Promise((resolve, reject) => {
                this.subscriptions.push(
                    this.globalService.getIPAddress()
                        .subscribe(
                            async res => {
                                resolve(res.ip);
                            },
                            error => {
                                reject(error);
                            }
                        )
                );
            })
            deviceData.ip = IP;
            return await this.authorizeThisDevice({
                deviceSignature: deviceData.DeviceID,
                deviceInfo: JSON.stringify(deviceData)
            });
        } catch (error) {
            return Promise.reject(error);
        }
    }

    public authorizeThisDevice(params: RequestAuthorizeThisDeviceDto): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscriptions.push(
                this.sfAuthenticatorApi.authorizeThisDevice(params)
                    .subscribe(
                        res => {
                            resolve(res.message);
                        },
                        error => {
                            reject(error.error.message);
                        }
                    )
            );
        })
    }

    private check2FA(check: RequestCheck2FADto): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscriptions.push(
                this.sfAuthenticatorApi.check2FA(check)
                    .subscribe(
                        res => {
                            resolve(res.data);
                        },
                        (error: HttpErrorResponse) => {
                            reject(error.error.message);
                        }
                    )
            )
        })
    }

    public update2FA(update: RequestUpdate2FADto): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscriptions.push(
                this.sfAuthenticatorApi.update2FA(update)
                    .subscribe(
                        res => {
                            resolve('You are verified in');
                        },
                        error => {
                            resolve('You are rejected in');
                        }
                    )
            )
        })
    }



}


// WEBPACK FOOTER //
// ./src/bloc/settings/authenticator.bloc.ts